<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mi CVU / Alias</b-card-header>
      <b-card-body>
        <div v-if="!cvuActive&&!cargando">
          <div class="margin-top text-center" style="color:#ff5955;">
<img src="@/assets/ic_icon_cvu_bank.png" style="max-height:150;max-width:150px;" />
              </div>
          <div class="margin-top text-center" style="color:#ff5955;">
Muchas gracias por tu interes
              </div>
              <div class="margin-top text-center" style="color:#ff5955;">
Te haremos saber cuando este disponible!
              </div>
              
              
    </div>
        <div v-else-if="cargando">
            </div>
        <div v-else-if="!hasToStartGeneratinGCVU">
                        <div class="margin-top text-center" style="color:#ff5955;">
¡Excelente! Ya tenés tu CVU. Ahora podés comenzar a enviar y recibir transferencias
              </div>
            <div class="row form-group">
              <div class="col-md-12">
                <label>Número de CVU</label>
                <base-input v-model="model.CVU" disabled></base-input>
              </div>
            </div>

            
            <div class="row form-group">
              <div class="col-md-12">
                <label>Alias</label>
                <base-input v-model="model.CVUAlias" disabled></base-input>
              </div>
            </div>

            <!-- <div class="row form-group">
              <div class="col-md-12">
                <button @click="start" class="btn btn-success">Empecemos</button>
              </div>
            </div> -->
            <div class="row form-group">
              <div class="col-md-12">
                <button @click="goToUpdateAliasCVU" class="btn btn-success">Modificar Alias</button>
                <button @click="doCopy" class="btn btn-success">Copiar Datos</button>
              </div>
            </div>
        </div>
        <form-wizard ref="wizard" :hide-buttons="true" title subtitle v-else>
          <!-- <template slot="step" scope="props">
            <wizard-step :tab="props.tab" :transition="props.transition" :index="props.index"></wizard-step>
          </template>-->
          <tab-content class="text-center" title="Inicio" icon="fas fa-arrow-right">
            <div>
              <div class="margin-top" style="color:#ff5955;">
                Vamos a generar tu CVU así podes enviarte dinero desde
                <br />tu cuenta bancaria, o que te envien dinero
                <br />
              </div>
              <div class="margin-top">
                <img src="@/assets/ic_icon_cvu_bank.png" style="max-height:150;max-width:150px;" />
              </div>
              <div class="margin-top">
                <button @click="start" class="btn btn-success">Empecemos</button>
              </div>
            </div>
          </tab-content>
          
<!-- Se comenta ya que ahora la carga de imagenes la hace la validación de identidad
          <tab-content class="text-center" title="Frente DNI" icon="fa fa-address-card">
            <div>
              <div class="margin-top" style="color:#ff5955;">
                Para tu seguridad, necesitamos una foto del frente de tu DNI
                <br />
              </div>

              <div class="margin-top" v-if="!hasImageDniFront">
                <img src="@/assets/ic_icon_cvu_dni1.png" style="max-height:150;max-width:150px;" />
              </div>

              <div class="margin-top">
                <image-uploader
                  id="Front"
                  :preview="true"
                  :className="['fileinput', { 'fileinput--loaded': hasImageDniFront }]"
                  capture="environment"
                  :maxHeight="300"
                  outputFormat="verbose"
                  @input="setImageFront"
                >
                  <label for="Front" slot="upload-label" style="cursor:pointer">
                    <figure>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <path
                          class="path1"
                          d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                        />
                      </svg>
                    </figure>
                    <span class="upload-caption">
                      {{
                      hasImageDniFront ? "Cambiar" : "Subir"
                      }}
                    </span>
                  </label>
                </image-uploader>
              </div>
            </div>
          </tab-content>
          <tab-content class="text-center" title="Atras DNI" icon="fa fa-address-card">
            <div>
              <div class="margin-top" style="color:#ff5955;">
                Ahora una de la parte de atrás de tu DNI
                <br />
              </div>

              <div class="margin-top" v-if="!hasImageDniBack">
                <img src="@/assets/ic_icon_cvu_dni2.png" style="max-height:150;max-width:150px;" />
              </div>

              <div class="margin-top">
                <image-uploader
                  id="Back"
                  :preview="true"
                  :className="['fileinput', { 'fileinput--loaded': hasImageDniBack }]"
                  capture="environment"
                  :maxHeight="300"
                  outputFormat="verbose"
                  @input="setImageBack"
                >
                  <label for="Back" slot="upload-label" style="cursor:pointer">
                    <figure>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                      >
                        <path
                          class="path1"
                          d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                        />
                      </svg>
                    </figure>
                    <span class="upload-caption">
                      {{
                      hasImageDniBack ? "Cambiar" : "Subir"
                      }}
                    </span>
                  </label>
                </image-uploader>
              </div>
            </div>
          </tab-content> -->

          <tab-content title="Datos" icon="fa fa-edit">
            <div v-if="isCommerce">
              <div class="margin-top text-center" style="color:#ff5955;">
                Confirmanos que estos sean tu nombre/razón social y CUIT/CUIL
                <br />
              </div>
            </div>
            <div v-else>
              <div class="margin-top text-center" style="color:#ff5955;">
                Confirmanos que estos sean tu nombre, apellido, nro de documento y CUIT/CUIL
                <br />
              </div>
            </div>            
            <div class="row form-group" v-if="!isCommerce">
              <div class="col-md-12">
                <label>Nombre</label>
                <base-input v-model="model.AccountName" disabled></base-input>
              </div>
            </div>
            <div class="row form-group" v-if="!isCommerce">
              <div class="col-md-12">
                <label>Apellido</label>
                <base-input v-model="model.AccountLastName" disabled></base-input>
              </div>
            </div>
            <div class="row form-group" v-if="isCommerce">
              <div class="col-md-12">
                <label>Nombre comercio</label>
                <base-input v-model="model.BusinessName" disabled></base-input>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <label>CUIT/CUIL</label>
                <base-input v-model="model.CUIT_CUIL" disabled></base-input>
              </div>
            </div>
            <div class="text-right">
              <button class="btn btn-success" @click="generateCVU">Finalizar</button>
            </div>
          </tab-content>
          <tab-content title="Resultado" icon="fa fa-fw fa-flag"></tab-content>
        </form-wizard>
      </b-card-body>
    </b-card>
    </div>
</template>

<style scoped>
.wizard-footer-right button {
  display: none !important;
}

.wizard-footer-left button {
  display: none !important;
}

.margin-top {
  margin-top: 10px;
}

input[type="file"] {
  display: none;
}
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import vSelect from "vue-select";

import notificationHelpers from "@/helpers/notificationHelpers";
import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);

import { Cropper, RectangleStencil } from "vue-advanced-cropper";
import store from "@/store";

import "vue-select/dist/vue-select.css";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

Vue.component("v-select", vSelect);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import { Store } from "vuex";
import { constants } from 'crypto';

export default {
  components: { FormWizard, TabContent, WizardStep, Cropper },
  data() {
    return {
        tiposImagenes:{Front:2, Back:3},
      model: {
        CVU: "",
        CVUAlias: "",
        AccountName: "",
        AccountLastName: "",
        BusinessName: "",
        CUIT_CUIL: ""
      },
      hasToStartGeneratinGCVU: true,
      hasImageDniFront: false,
      imageDniFront: null,
      resultImageDniFront: null,
      hasImageDniBack: false,
      imageDniBack: null,
      resultImageDniBack: null,
      AccountName: "",
      AccountLastName: "",
      BusinessName: "",
      CUIT_CUIL: "",
      isCommerce: false,
      cargando:true,
      cvuActive:false,
      message: "Copiando datos.."
    };
  },
  methods: {
    start() {
      let context = this;
      context.$refs.wizard.nextTab();
    },
    setImageFront: function(output) {
      let context = this;
      context.hasImageDniFront = true;
      context.imageDniFront = output;
      context.uploadFoto(output,context.tiposImagenes.Front);
      context.$refs.wizard.nextTab();
    },
    setImageBack: function(output) {
      let context = this;
      context.hasImageDniBack = true;
      context.imageDniBack = output;
      context.uploadFoto(output,context.tiposImagenes.Back);
      context.$refs.wizard.nextTab();
    },
    uploadFoto: function(output, imageType) {
      let context = this;
      let req = {};

      req.Extension = output.type.replace("image/",'');
      
      req.FileStream = output.dataUrl.replace("data:image/"+req.Extension+";base64,",'');

      req.CroppedImage = true;
      req.ImageTypeID = imageType;

      axiosHelpers.axiosPost("Account/AddImage", req, context, function(data) {
      });
    },
    generateCVU:function(){
        let context = this;

        axiosHelpers.axiosPost("Account/GenerateAccountCVU", context.model, context, function(data) {
            context.model.CVU = data.ResponseVM.CVU;
            context.model.CVUAlias = data.ResponseVM.CVUAlias;
            context.hasToStartGeneratinGCVU = !context.model.CVU;
      });
    },
    goToUpdateAliasCVU()
    {
      this.$router.push({
        name: "updatealiascvu",
        params: { AliasCVU: this.model.CVUAlias }
      });
    },
    doCopy: function () {

      let context = this;
      let isCommerceAccount = store.getters.isCommerce == true;
      let isAssociatedCommerceAccount = store.getters.isAssociatedCommerce == true;

      let titularCuenta;
      if (isAssociatedCommerceAccount) {
        titularCuenta = (context.model.AccountName + ' ' + context.model.AccountLastName).trim();
      } else if (isCommerceAccount) {
        titularCuenta = context.model.BusinessName || context.model.AccountName;
      } else {
        titularCuenta = context.model.AccountName + ' ' + context.model.AccountLastName;
      }

      let documentoLine = '';
      if (isAssociatedCommerceAccount) {
        documentoLine = '\nCUIT/CUIL: \n' + (context.model.CUIT_CUIL || '');
      } else if (isCommerceAccount) {
        documentoLine = '\nCUIT/CUIL: \n' + (context.model.CUIT_CUIL || '');
      } else {
        documentoLine = '\nDocumento: \n' + (context.model.DocumentNumber || context.model.CUIT_CUIL || '');
      }

      context.message = 'Nombre de la Entidad: \nResimple \nNúmero de CVU: \n' 
      + context.model.CVU +
      '\nAlias: \n' + context.model.CVUAlias + '\nTitular de la cuenta: \n' + titularCuenta + documentoLine;

        this.$copyText(context.message).then(function (e) {
         notificationHelpers.showSuccess('Información', 'Los datos han sido copiados al portapapeles', context);
        }, function (e) {
          alert('Error al copiar los datos')
        })
    }
  },
  beforeMount: function() {
    let context = this;
    axiosHelpers.axiosPost("Account/GetAccountCVU", {}, context, function(
      data
    ) {

      if(!data.ResponseVM.IdentityWasVerificated){
        context.$router.push("verificacionidentidad");
      }

      context.cargando=false;
      context.isCommerce = store.getters.isCommerce;
      context.model = data.ResponseVM;
      context.cvuActive = data.ResponseVM.CVUServiceActive;
      context.hasToStartGeneratinGCVU = !context.model.CVU;
    });
  }
};
</script>